function initAuthTokenChecker(token) {
  const urlSegments = window.location.pathname.split('/');

  if (urlSegments.length >= 1 && urlSegments[1].toLocaleLowerCase() === 'home') {
    return; //Frontends hosted in "home" doesn't need to call keep alive
  }

  setInterval(function () {
   fetch('/ui/sessionkeepalive.aspx', {
      credentials: 'include',
      headers: {
        authorization: token
      }
    })
      .then(function (resp) { })
      .catch(function (err) {
        location.href = '/RRDCommon/SignOut.aspx';
      });
  }, 1000 * 60);
}

export { initAuthTokenChecker };

